import fetchAPI from '../../../utils/fetchApi';

// eslint-disable-next-line max-params
export default async function getToysItems(pageKey, page, l1s, l2s, price, filters, p, mileage) {
  try {
    return await fetchAPI({
      url: `/cp/api/${pageKey}?page=${page}${l1s.length ? `&l1=${l1s.map(({ value }) => value).join(',')}` : ''}${l2s.length ? `&l2=${l2s.map(({ value }) => value).join(',')}` : ''}${filters.length ? `&filters=${filters.join()}` : ''}${price ? `&price=${price}` : ''}${mileage ? `&mileage=${mileage.join(':')}` : ''}${p ? `&p=${p}` : ''}`,
      method: 'GET',
    });
  } catch {
    return false;
  }
}
